/* eslint-disable */
import $ from 'jquery'
import { Utils, baseUrl } from './config'
$(()=>{
  $.ajax({
    url: `${baseUrl.apiUrl}/current_account`,
    type: 'GET',
    dataType: 'json',
    headers: {
      'Content-Type': 'application/json'
    },
    xhrFields: {
      withCredentials: true
    }
  }).done(function(d) {
    $('.apply-new-header .isApplyLogin').show();
  }).fail(function(d) {
    $('.apply-new-header .isntApplyLogin').show();
  }).always(function(d) {});
})



// WEBPACK FOOTER //
// ./src/apply.entry.js